import {sort}from "../actionTypes/sortingTypes";

export const setSorting = (field_name, direction) => ({
  type: sort.SET_SORTING,
  payload: { field_name, direction }
});

export const resetSorting = () => ({
  type: sort.RESET_SORTING
});

export const toggleSorting = (field_name) => ({
  type: sort.TOGGLE_SORTING,
  payload: { field_name }
});
